'use client'

import { useSearchParams } from 'next/navigation'
import Link, { LinkProps } from 'next/link'
import { PropsWithChildren } from 'react'

type LinkWithQueryProps = LinkProps & {
  preserveQuery?: boolean
  query?: Record<string, string | number | boolean | undefined>
  className?: string
}

const LinkWithQuery = ({
  href,
  preserveQuery = true,
  query,
  ...props
}: PropsWithChildren<LinkWithQueryProps>) => {
  const searchParams = useSearchParams()

  // Convert searchParams to object, handling null case
  const currentQuery = searchParams
    ? Object.fromEntries(searchParams.entries())
    : {}

  // If preserveQuery is false, only use the provided query
  const finalQuery = preserveQuery ? { ...currentQuery, ...query } : query || {}

  // Remove undefined values from query
  const cleanQuery = Object.fromEntries(
    Object.entries(finalQuery).filter(([_, value]) => value !== undefined)
  )

  return (
    <Link
      href={{
        pathname: typeof href === 'string' ? href : href?.pathname || '/',
        query: cleanQuery,
      }}
      {...props}
    />
  )
}

export default LinkWithQuery
